import { Container } from "react-bootstrap";
import CategorizedProductCarousel from "../../components/Home/CategorizedProductCarousel";

const RelatedProducts = ({ setShow, singleProductData }) => {
  console.log("singleProductData___", singleProductData);
  return (
    <>
      <Container>
        {" "}
        {
          <CategorizedProductCarousel
            setShow={setShow}
            title={"You might also like"}
            productList={singleProductData?.result?.relatedProducts}
          />
        }
      </Container>
    </>
  );
};
export default RelatedProducts;
